import React from 'react'
import SharedNavbar from '../components/SharedNavbar'
import { Route, useLocation } from 'react-router-dom';

import { Suspense } from 'react';
import { Switch } from 'react-router-dom';
import Whatsapp from '../components/FloatingIcons/Whatsapp';
import ErrorBoundary from '../components/ErrorBoundary';
// Not lazy: the loading fallback must not depend on fetching a chunk itself.
import Loader from '../components/Spinner/Spinner';
import lazyWithRetry from '../utils/lazyWithRetry';

// Lazy Loaded Components
const Footer = lazyWithRetry(() => import('../components/SharedFooter'));
const Home = lazyWithRetry(() => import('../pages/Home'));
const Industries = lazyWithRetry(() => import('../pages/Industries'));
const AboutUs = lazyWithRetry(() => import('../pages/AboutUs'));
const ContactUs = lazyWithRetry(() => import('../pages/ContactUs'));
const Privacy = lazyWithRetry(() => import('../pages/Privacy'));
const Services = lazyWithRetry(() => import('../pages/Services'));
const ProductDev = lazyWithRetry(() => import('../pages/ServicePages/ProductDev'));
const Portfolio = lazyWithRetry(() => import('../pages/Portfolio'));
const Games = lazyWithRetry(() => import('../pages/PortfolioPages/Games'));
const DCPoker = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/DCPoker'));
const CasinoGames = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/CasinoGames'));
const Rummy = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/Rummy'));
const FantasySports = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/FantasySports'));
const Ludo = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/Ludo'));
const Trivia = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/Trivia'));
const BlackJack = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/BlackJack'));
const TeenPatti = lazyWithRetry(() => import('../pages/PortfolioPages/GamesPages/TeenPatti'));
const ThinkingAndDesign = lazyWithRetry(() => import('../pages/ServicePages/ThinkingAndDesign'));
const SoftwareDev = lazyWithRetry(() => import('../pages/ServicePages/SoftwareDev'));
const Marketing = lazyWithRetry(() => import('../pages/ServicePages/Marketing'));
const ProductGrowth = lazyWithRetry(() => import('../pages/ServicePages/ProductGrowth'));
const ResearchAndInnovative = lazyWithRetry(() => import('../pages/ServicePages/ResearchAndInnovative'));
const Metaverse = lazyWithRetry(() => import('../pages/IndustryPages/Metaverse'));
const Blockchain = lazyWithRetry(() => import('../pages/IndustryPages/Blockchain'));
const AIML = lazyWithRetry(() => import('../pages/IndustryPages/AIML'));
const Fintech = lazyWithRetry(() => import('../pages/IndustryPages/Fintech'));
const Healthcare = lazyWithRetry(() => import('../pages/IndustryPages/Healthcare'));
const LandingPage = lazyWithRetry(() => import('../pages/landingPage/landingPage'));
const LandingPageTwo = lazyWithRetry(() => import('../pages/landingPage2/landingPage'));
const ThankyouPage = lazyWithRetry(() => import('../pages/thankyouPage'));
const ThankyouPageSoft = lazyWithRetry(() => import('../pages/thankyouPageSoft'));
const Blog = lazyWithRetry(() => import('../pages/Blog/Blog'));
const BlogDetail = lazyWithRetry(() => import('../pages/Blog/DetailsPage'));
const My404Component = lazyWithRetry(() => import('../pages/My404Component'));
const Promotion = lazyWithRetry(() => import('../pages/marketing/promote'));
// Programmatic SEO: service x city landing pages (src/data/pseo)
const LocationsHub = lazyWithRetry(() => import('../pages/PseoPages/LocationsHub'));
const ServiceLocation = lazyWithRetry(() => import('../pages/PseoPages/ServiceLocation'));

function PublicLayout() {

    const location = useLocation();

    
    // Define the routes where WhatsApp component should be hidden
    const hiddenRoutes = [
        '/landing-page/igaming',
        '/landing-page/software-development',
        '/thankyou-page/igaming',
        '/thankyou-page/software-development',
        '/blog-detail',
        '/software-development'
        
    ];

    // // Check if the current path is in hidden routes
    // const shouldHideWhatsApp = hiddenRoutes.includes(location.pathname);

     const hideNavAndFooterRoutes = [
        '/software-development',
        '/landing-page/igaming',
        '/landing-page/software',
        '/thankyou-page/igaming',
        '/thankyou-page/software-development'
    ];

    const shouldHideWhatsApp = hiddenRoutes.includes(location.pathname);
    const shouldHideNavAndFooter = hideNavAndFooterRoutes.includes(location.pathname);
    
    return (
        <ErrorBoundary resetKey={location.pathname}>
        <Suspense fallback={<Loader />}>
             {!shouldHideNavAndFooter && <SharedNavbar />}
            <Switch>
          
                <Route exact path="/" component={Home}></Route>
                <Route exact path="/industries" component={Industries}></Route>
                <Route exact path="/about-us" component={AboutUs}></Route>
                <Route exact path="/contact-us" component={ContactUs}></Route>
                <Route exact path="/privacy-policy" component={Privacy}></Route>
                <Route exact path="/services" component={Services}></Route>
                <Route exact path="/portfolio" component={Portfolio}></Route>
                <Route exact path="/services/product-development" component={ProductDev}></Route>
                <Route exact path="/services/thinking-and-design" component={ThinkingAndDesign}></Route>
                <Route exact path="/services/software-development" component={SoftwareDev}></Route>
                <Route exact path="/services/product-growth" component={ProductGrowth}></Route>
                <Route exact path="/services/research-and-innovative" component={ResearchAndInnovative}></Route>
                {/* Programmatic SEO routes. Must stay BELOW the exact service
                    routes above so the canonical service pages always win. */}
                <Route exact path="/services/locations" component={LocationsHub}></Route>
                <Route exact path="/services/:pseoSlug" component={ServiceLocation}></Route>
                <Route exact path="/industries/igaming" component={Games}></Route>
                <Route exact path="/industries/games/dc-poker" component={DCPoker}></Route>
                <Route exact path="/industries/games/teen-patti" component={TeenPatti}></Route>
                <Route exact path="/industries/games/blackjack" component={BlackJack}></Route>
                <Route exact path="/industries/games/trivia" component={Trivia}></Route>
                <Route exact path="/industries/games/ludo" component={Ludo}></Route>
                <Route exact path="/industries/games/fantasy-sports" component={FantasySports}></Route>
                <Route exact path="/industries/games/rummy" component={Rummy}></Route>
                <Route exact path="/industries/games/casino-games" component={CasinoGames}></Route>
                <Route exact path="/industries/metaverse" component={Metaverse}></Route>
                <Route exact path="/industries/blockchain" component={Blockchain}></Route>
                <Route exact path="/industries/ai-ml" component={AIML}></Route>
                <Route exact path="/industries/fintech" component={Fintech}></Route>
                <Route exact path="/industries/marketing" component={Marketing}></Route>
                <Route exact path="/industries/healthcare" component={Healthcare}></Route>
                {/* Programmatic SEO for industry verticals. Must stay BELOW every
                    exact /industries/* route above. The /industries/games/* routes
                    have two path segments so they can't be shadowed by this. */}
                <Route exact path="/industries/:pseoSlug" component={ServiceLocation}></Route>
                <Route exact path="/landing-page/igaming" component={LandingPage}></Route>
                <Route exact path="/landing-page/software" component={LandingPageTwo}></Route>
                <Route exact path="/thankyou-page/igaming" component={ThankyouPage}></Route>
                <Route exact path="/thankyou-page/software-development" component={ThankyouPageSoft}></Route>
                <Route exact path="/blog" component={Blog}></Route>
                <Route exact path="/blog-detail/:slug" component={BlogDetail}></Route>
                <Route exact path="/thankyou-page/software-development" component={ThankyouPageSoft}></Route>
                <Route exact path="/software-development" component={Promotion}></Route>
                <Route exact path="*" component={Home} />
            </Switch>
            {!shouldHideWhatsApp && <Whatsapp />}
              {!shouldHideNavAndFooter && <Footer />}
        </Suspense>
        </ErrorBoundary>
    )
}

export default PublicLayout